
//AUTHENTICATIONS
export const ADMIN_LOGIN = "auth/login";
export const FORGOT_PASSWORD = "auth/forgot-password";
export const OTP_VERIFY = "auth/verify-forgot-password-otp";
export const RESEND_OTP = "auth/change-password";
export const CHANGE_PASSWORD = "auth/change-password";
export const UPDATE_FCM_TOKEN = "auth/profile/save-fcmToken";
export const REMOVE_FCM_TOKEN = "auth/profile/remove-fcmToken";


//DASHBOARD
export const DASHBOARD_APIS = "home/dashboard-data";
export const SALES_DETAILS_LISTING = "home/dashboard-data-total-sales";
export const SALES_PRICE_DETAILS_LISTING = "home/dashboard-data-total-price";
export const TOTAL_ORDER_DETAILS_LISTING = "home/dashboard-data-total-orders";

//CATEGORIES
export const CATEGORY_LISTING = "category/get-all-subcategory";
export const CATEGORY_LISTING_PAGINATE = "category/search/search-category";
export const CREATE_CATEGORY = "category/create-subcategory";
export const STATUS_UPDATE_CATEGORY = "category/toggle-subCategory";
export const DELETE_CATEGORY = "category/delete-subCategory";
export const EDIT_CATEGORY = "category/edit-subcategory";

//SUB CATEGORIES
export const SUB_CATEGORY_LISTING = "category/get-subcategory-wise-subsubcategory";
export const SUB_CATEGORY_LISTING_PAGINATE = "category/search/search-subcategory";
export const SUB_CATEGORY_DETAILS = "category/sub-subcategory/";
export const SUB_CATEGORY_PRODUCTS_LISTING = "product/list-product-subcategory";
export const CREATE_SUB_CATEGORY = "category/create-sub-subcategory";
export const STATUS_UPDATE_SUB_CATEGORY = "category/toggle-sub-subcategory";
export const VTO_STATUS_UPDATE_SUB_CATEGORY = "category/toggle-vto-sub-subcategory";
export const EDIT_SUB_CATEGORY = "category/edit-sub-subcategory";
export const DELETE_SUB_CATEGORY = "category/delete-sub-subcategory";

//PROMO CODES
export const CREATE_PROMO_CODES = "offers/create-offer";
export const EDIT_PROMO_CODES = "offers/edit-offer";
export const PROMO_CODES_LISTING = "offers/all-offers";
export const ACTIVE_PROMO_CODES_LISTING = "offers/list-active-offers";
export const IN_ACTIVE_PROMO_CODES_LISTING = "offers/list-inactive-offers";
export const ACTIVE_PROMO_CODES_COUNT = "promocodes/active-promocode-count";
export const IN_ACTIVE_PROMO_CODES_COUNT = "promocodes/inactive-promocode-count";
export const DELETE_PROMO_CODE = "offers/delete-offer";
export const STATUS_UPDATE_PROMO_CODE = "offers/toggle-active-status";
export const OFFER_LISTING = "offers/list-offer-types";
export const APPROVE_PROMO = "offers/approve-offer";


export const CREATE_UPDATE_OFFER_PROMOCODES = "offers/create-update-offer-promocode";
export const GET_COMPLETE_OFFER_PROMOCODES = "offers/get-complete-offer-promocode";
export const GET_OFFER_PROMOCODE_BY_ID = "offers/get-offer-promocode-by-id";
export const UPDATE_OFFER_PROMOCODE_STATUS = "offers/update-offer-promocode-status";


//MANUFACTURER 
export const CREATE_MANUFACTURER = "manufacturer/create-manufacturer";
export const UPDATE_MANUFACTURER = "manufacturer/edit-manufacturer";
export const MANUFACTURER_LISTING_VENDOR_PANEL = "manufacturer/get-all-manufacturers-for-vendor-panel";
export const MANUFACTURER_LISTING_PAGINATE = "manufacturer/search/search-manufacturer";
export const MANUFACTURER_SINGLE_LISTING = "manufacturer/get-single-manufacturer/";
export const MANUFACTURER_DELETE = "manufacturer/delete-manufacturer";
export const STORE_DETAILS_LISTING = "manufacturer/get-manufacturer-details";
export const STATUS_UPDATE_TIMING = "manufacturer/change-store-timings";

export const REGISTER_VENDOR = "manufacturer/register-vendor";
export const VERIFY_VENDOR = "manufacturer/verify-vendor";

//PRODUCTS 
// export const CREATE_PRODUCTS = "product/create";
export const CREATE_PRODUCTS = "product/create-product-with-size";
export const UPDATE_PRODUCTS = "product/edit";
export const PRODUCTS_LISTING = "product/get-all-products-vendor-panel";
export const PRODUCTS_SUB_CATEGORY_LISTING = "product/list-product-subcategory-to-add/";
export const ADD_PRODUCTS_SUBCATEGORY = "product/add-product-subcategory";
export const INVENTORY_LISTING_PAGINATE = "product/search-products";
export const PRODUCTS_OUT_STOCK_LISTING = "product/get-all-out-of-stock-products";
export const PRODUCTS_LOW_STOCK_LISTING = "product/get-all-low-stock-products";
export const PRODUCTS_VARIANTS = "product/get-product-variants";
export const PRODUCTS_SINGLE_LISTING = "product/product-details/";
export const DELETE_PRODUCT = "product/delete-product";
export const DELETE_SUB_CATEGORY_PRODUCT = "product/remove-product-from-subcategory";
export const STATUS_UPDATE_PRODUCT = "product/change-product-status";
// export const BULK_UPLOAD = "product/bulk-upload";
export const BULK_UPLOAD_PRODUCT = "product/bulk-upload-products";
export const BULK_UPLOAD_IMAGE = "upload-product-images";
export const PRODUCT_IMAGE_DELETE = "product/productImage";

export const DOWNLOAD_PRODUCTS_EXCEL = "product/download-products-excel";


export const ROLES_PAGINATE = "roles/search/search-roles";

//Orders
export const ORDERS_LISTING = "order/get-all-user-orders";
export const COMPLETED_ORDERS_LISTING = "order/get-all-user-orders";
export const REJECTED_ORDERS_LISTING = "order/get-all-user-orders";
export const ORDERS_DETAILS_LISTING = "order/get-all-user-orders-detail";
export const DELETE_ORDER_ITEM = "order/delete-order";
export const APPROVE_ORDER = "order/approve-order";
export const REJECT_ORDER = "order/reject-order";
export const DELETE_PRODUCT_ITEM = "order/cancel-user-order-product";
export const SHIP_ORDER = "order/initiate-shipping-order";
export const PAYMENT_LISTING_URL = "order/all-transactions";
export const EXCHANGE_REJECT_ORDER = "order/update-return";
export const UPDATE_PAYMENT_STATUS = "order/update-payment-status"; 
export const DOWNLOAD_VENDOR_INVOICE = "order/download-invoice"; 
export const DOWNLOAD_BULK_VENDOR_INVOICE = "order/download-bulk-vendor-invoice";
export const DOWNLOAD_CUSTOMER_INVOICE = "order/download-customer-invoice"; 

export const DOWNLOAD_ORDERS_EXCEL = "order/download-orders-excel";

//Tracking
export const TRACKING_LISTING = "order/tracking-orders-logistics";
export const UPDATE_TRACKING_STATUS = "order/update-tracking-status";


//Banner
export const CREATE_BANNER_URL = "banners/create-banner";
export const EDIT_BANNER_URL = "banners/update-banner";
export const BANNER_LISTING_URL = "banners/list-banners";
export const DELETE_BANNER_URL = "banners/remove-banner";

//Additional Banner APIs
export const GET_BANNER_BY_ID = "banners/get-banner-by-id";
export const CREATE_UPDATE_BANNER = "banners/create-update-banner";
export const UPDATE_BANNER_STATUS = "banners/update-banner-status";


//Brand
export const CREATE_BRAND_URL = "brand/create-brand";
export const EDIT_BRAND_URL = "brand/edit-brand";
export const BRAND_LISTING_URL = "brand/list-brands";
export const FETCH_ALL_BRAND_ADMIN = "brand/list-brands-vendor";
export const DELETE_BRAND_URL = "brand/delete-brand";
export const BRANDS_SINGLE_LISTING = "brand/brand-detail";
export const DELETE_BRAND_CATEGORY = "brand/delete-brand-category";


//Notifications
export const NOTIFICATION_LISTING = "auth/notifications/list";
export const MARK_AS_READ_NOTIFICATION_URL = "auth/notifications/read";

//Support
export const LIST_MESSAGE_SUPPORT = "chat/list-messages";
export const LIST_USER_MESSAGE_SUPPORT = "chat/list-chat-heads";
export const SEND_MESSAGE_SUPPORT = "chat/send-message";
export const MARK_AS_RESOLVED_SUPPORT = "chat/mark-as-resolved";
export const DELETE_CHAT_SUPPORT = "chat/delete-chat";

//Size Chart
export const SIZE_CHART_LISTING = "size-chart/get-size-chart";
export const SIZE_CHART_SIZES_TYPES = "sizechart/sizes-types";
export const CREATE_SIZE_CHART = "sizechart/size-chart-values";
export const GET_SIZE_CHART = "sizechart/size-chart-values";

//ADMIN SETTINGS
export const GET_ADMIN_SETTINGS_URL = "adminSettings/get-admin-setting";
export const UPDATE_ADMIN_SETTINGS_URL = "adminSettings/update-admin-setting";


//SMART INVENTORY
export const GET_SMART_INVENTORY = "smartInventory/get-vendor-data";
export const UPDATE_SMART_INVENTORY = "smartInventory/update-vendor-data";
export const SYNC_SMART_INVENTORY = "smartInventory/perform-initial-sync";

export const GET_EXTERNAL_SUB_CATEGORY = "smartInventory/get-external-subcategory-by-vendor";
export const GET_BRAND_CATEGORY_HIERARCHY = "smartInventory/brand-categories-hierarchy";
export const SAVE_CATEGORY_MAPPINGS = 'smartInventory/save-category-mappings';
export const GET_CATEGORY_MAPPING = 'smartInventory/get-category-mappings';

export const GET_VENDOR_SIZE_MAPPINGS = 'smartInventory/get-vendor-mapping-with-sizes';
export const UPDATE_VENDOR_SIZE_MAPPINGS = 'smartInventory/update-vendor-mapping-with-sizes';

//Analytics
export const GET_SEARCH_ANALYTICS = "analytics/get-search-analytics";
export const GET_USER_ACTIVITY_ANALYTICS = "analytics/get-user-activity-analytics";
export const GET_LOCATION_ANALYTICS = "analytics/get-location-analytics";
export const GET_PROMOCODE_ANALYTICS = "analytics/get-promocode-analytics";

//AutoNotifications
export const GET_ALL_AUTO_NOTIFICATION = "autoNotification/get-all-auto-notification";
export const UPLOAD_BULK_AUTO_NOTIFICATIONS = "autoNotification/upload-bulk-auto-notifications";
export const SCHEDULE_AUTO_NOTIFICATIONS = "autoNotification/schedule-auto-notification";
export const TOGGLE_AUTO_NOTIFICATION_STATUS = "autoNotification/toggle-auto-notification-status";
